import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const DoesNotRequireAuth = () => {
	const { getToken } = useAuth();

	return getToken()?.token ? <Navigate to='/' /> : <Outlet />;
};

export default DoesNotRequireAuth;
